import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { MemoryStorageService } from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-doa-file-upload',
  templateUrl: './doa-file-upload.component.html',
  styleUrls: ['./doa-file-upload.component.css']
})
export class DoaFileUploadComponent implements OnInit {

  lstDOASetting = [];
  lstDOAExelUpload = [];

  docTypeList = [];
  selectedDocumentType: any = {};

  isOpenDoctypeModel: boolean = false;
  isDisplayDocModel = false;

  isDisplaySettingData: boolean = true;

  doaDetail: any = {};
  fileControlType = 'file';
  selectedFile = "No file selected.";
  fileTitle = "Choose file";

  constructor(private dataService: DataService, private commonService: CommonService, private router: Router, private encryptDecryptservice: EncryptDecryptService
    ,private memorystore: MemoryStorageService
  ) {


  }

  ngOnInit(): void {

    this.getDOAData();
    this.getDOASettingData();
    this.getDOAExelUploadData();

    this.getDocumentType();
  }

  getDocumentType() {
    this.docTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('document-types', params).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          for (var i = 0; i < res.data.length; i++) {
            this.docTypeList.push({ 'docTypeId': res.data[i].document_type_id, 'docTypeName': res.data[i].document_type_name });
          }
          this.selectedDocumentType = this.docTypeList[0];
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    }, error => {
      this.commonService.showMessageBox(error.toString());
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })
  }

  getDOAData() {
    this.doaDetail = { project: 'DOA Approval', region: 'ASIA', businessUnit: 'India', country: 'India', document: 'DOA Parallel' }
  }

  getDOASettingData() {
    this.lstDOASetting.push({ 'Approver Name': 'Peter', 'Level': '1', 'Approval Amount': '8000', 'Cost Center': 'CC001', 'Vendor Code': 'V001' });
    this.lstDOASetting.push({ 'Approver Name': 'John', 'Level': '2', 'Approval Amount': '10000', 'Cost Center': 'CC001', 'Vendor Code': 'V001' });
    this.lstDOASetting.push({ 'Approver Name': 'Justin', 'Level': '3', 'Approval Amount': '99999999', 'Cost Center': 'CC001', 'Vendor Code': 'V001' });
  }

  getDOAExelUploadData() {
    this.lstDOAExelUpload.push({ 'File Name': 'DOA_Template_test1_1.xlsx', 'Time Stamp': '12-Sep-2021 3:23:16 PM', 'Action By': '745752', 'Status': 'SUCCESS', 'Download': 'Download File' });
    this.lstDOAExelUpload.push({ 'File Name': 'DOA_Template_20210813143841111.xlsx', 'Time Stamp': '16-Aug-2021 3:24:07 PM', 'Action By': '745752', 'Status': 'SUCCESS', 'Download': 'Download File' });
    this.lstDOAExelUpload.push({ 'File Name': 'DOA_Template_20210813143841888.xlsx', 'Time Stamp': '16-Aug-2021 11:16:15 AM', 'Action By': '745752', 'Status': 'SUCCESS', 'Download': 'Download File' });
    this.lstDOAExelUpload.push({ 'File Name': 'DOA_Template_20210813143841999.xlsx', 'Time Stamp': '16-Aug-2021 11:16:15 AM', 'Action By': '745752', 'Status': 'SUCCESS', 'Download': 'Download File' });
    this.lstDOAExelUpload.push({ 'File Name': 'DOA_Template_20210816095705Part1.xlsx', 'Time Stamp': '16-Aug-2021 10:11:47 AM', 'Action By': '745752', 'Status': 'SUCCESS', 'Download': 'Download File' });
  }

  onChangeDoctype(doc) {
    this.isOpenDoctypeModel = false;
    this.selectedDocumentType = doc;
  }

  downloadTemplate() {

  }

  onSelectFile(file) {
    this.selectedFile = file.target.files[0].name;
  }

  uploadFile() {

  }
}
